$( document ).ready(function() {
    $(window).scroll(function(){
        var $windowTop = $(window).scrollTop();
        if($windowTop >= 680){
            $('.c-sticky-atc-bar').addClass('is-sticky');
        }else{
            $('.c-sticky-atc-bar').removeClass('is-sticky');
        }
    })


    $('.c-sticky-atc-bar__btn').click(function(){
        var $targetTop = $('.product__details').offset().top - 70;
        $('html,body').animate({scrollTop: $targetTop}, 400);
    })
});